<template>
  <div class="crud-container" data-aos="fade-right">
    <CrudToolbar
      title="Rutinas"
      v-model="filtroTexto"
      searchPlaceholder="Buscar por nombre..."
    >
      <template #actions>
        <button
          class="btn btn-areas btn-header"
          @click="abrirModalAreas"
          title="Gestionar áreas de trabajo"
        >
          <i class="bi bi-diagram-3-fill"></i>
          <span class="btn-header-texto ms-2">Áreas</span>
        </button>
        <button class="btn btn-nuevo btn-header" @click="abrirModalCrear">
          <i class="bi bi-plus-lg"></i>
          <span class="btn-header-texto ms-2">Nueva rutina</span>
        </button>
      </template>
    </CrudToolbar>

    <!-- ══════════════════════ TABLA DESKTOP ══════════════════════ -->
    <div class="divisan-table-container shadow-lg d-none d-lg-block">
      <div v-if="store.cargando" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
        <p class="text-cafe mt-2">Cargando rutinas...</p>
      </div>

      <table v-else class="table table-divisan align-middle mb-0">
        <thead>
          <tr>
            <th class="ps-4">
              <ColumnFilterMenu
                field="nombre"
                label="Nombre"
                :filterable="false"
                :items="rutinasFiltradas"
                :sortField="sortKey"
                :sortAsc="sortDir === 'asc'"
                @update:sort="onSort"
              />
            </th>
            <th class="text-center">
              <ColumnFilterMenu
                field="area_nombre"
                label="Área"
                :items="rutinasBuscadas"
                :sortField="sortKey"
                :sortAsc="sortDir === 'asc'"
                :modelValue="filtroAreaSet"
                @update:modelValue="filtroAreaSet = $event"
                @update:sort="onSort"
              />
            </th>
            <th class="text-center">
              <ColumnFilterMenu
                field="periodicidad"
                label="Periodicidad"
                :filterable="false"
                :items="rutinasFiltradas"
                :sortField="sortKey"
                :sortAsc="sortDir === 'asc'"
                @update:sort="onSort"
              />
            </th>
            <th class="text-center">Actividades</th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="rut in rutinasPaginadas" :key="rut.id">
            <td class="ps-4">
              <span class="fw-bold text-cafe">{{ rut.nombre }}</span>
              <div v-if="rut.descripcion" class="descripcion-corta">
                {{ rut.descripcion }}
              </div>
            </td>
            <td class="text-center">
              <span v-if="rut.area_nombre" class="badge-area">
                {{ rut.area_nombre }}
              </span>
              <span v-else class="text-muted-divisan">—</span>
            </td>
            <td class="text-center">
              <div class="periodicidad-cell">
                <span class="fw-bold text-cafe">{{
                  labelPeriodicidad(rut.periodicidad)
                }}</span>
                <small v-if="rut.frecuencia_dias" class="text-verde d-block">
                  c/{{ rut.frecuencia_dias }} días
                </small>
              </div>
            </td>
            <td class="text-center">
              <span class="conteo-badge">
                <i class="bi bi-list-check me-1"></i>
                {{ rut.rutina_actividades?.length || 0 }}
              </span>
            </td>
            <td class="text-center">
              <div class="d-flex justify-content-center gap-2">
                <button
                  class="btn-circular"
                  @click="abrirDetalle(rut)"
                  title="Ver detalle"
                >
                  <i class="bi bi-eye text-dark"></i>
                </button>
                <button
                  class="btn-circular"
                  @click="abrirModalEditar(rut)"
                  title="Editar"
                >
                  <i class="bi bi-pencil-square text-verde"></i>
                </button>
                <button
                  class="btn-circular text-danger"
                  @click="confirmarEliminar(rut)"
                  title="Desactivar"
                >
                  <i class="bi bi-trash3-fill"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="rutinasPaginadas.length === 0">
            <td colspan="5" class="text-center py-5 text-cafe opacity-50 fw-bold">
              No se encontraron resultados
            </td>
          </tr>
        </tbody>
      </table>

      <div class="paginacion-wrapper">
        <div class="pag-izq">
          <small class="pag-info"
            >{{ rangoInicio }}–{{ rangoFin }} de
            {{ rutinasOrdenadas.length }} rutinas</small
          >
          <div class="por-pagina-wrap">
            <label class="por-pagina-label">Filas:</label>
            <select
              class="por-pagina-select"
              :value="paginacionStore.porPagina"
              @change="cambiarPorPagina(Number($event.target.value))"
            >
              <option v-for="n in paginacionStore.opcionesPorPagina" :key="n" :value="n">
                {{ n }}
              </option>
            </select>
          </div>
        </div>
        <div class="pag-der">
          <button
            class="btn-pag"
            :disabled="paginaActual === 1"
            @click="paginaActual = 1"
          >
            <i class="bi bi-chevron-double-left"></i>
          </button>
          <button class="btn-pag" :disabled="paginaActual === 1" @click="paginaActual--">
            <i class="bi bi-chevron-left"></i>
          </button>
          <template v-for="p in paginasVisibles" :key="p">
            <span v-if="p === '...'" class="pag-ellipsis">…</span>
            <button
              v-else
              :class="['btn-pag-num', { activo: p === paginaActual }]"
              @click="paginaActual = p"
            >
              {{ p }}
            </button>
          </template>
          <button
            class="btn-pag"
            :disabled="paginaActual === totalPaginas"
            @click="paginaActual++"
          >
            <i class="bi bi-chevron-right"></i>
          </button>
          <button
            class="btn-pag"
            :disabled="paginaActual === totalPaginas"
            @click="paginaActual = totalPaginas"
          >
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ══════════════════════ CARDS MÓVIL ══════════════════════ -->
    <div class="d-lg-none">
      <div v-if="store.cargando" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
      </div>
      <div
        v-else
        v-for="rut in rutinasPaginadas"
        :key="'mob-' + rut.id"
        class="divisan-mobile-card mb-3 p-3 shadow-sm"
      >
        <div class="d-flex justify-content-between align-items-start mb-2">
          <span class="fw-bold text-cafe">{{ rut.nombre }}</span>
          <span v-if="rut.area_nombre" class="badge-area">{{ rut.area_nombre }}</span>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-12">
            <label class="small text-muted d-block">Periodicidad</label>
            <span class="fw-bold text-cafe small">{{
              labelPeriodicidad(rut.periodicidad)
            }}</span>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center pt-2 border-top">
          <span class="conteo-badge">
            <i class="bi bi-list-check me-1"></i
            >{{ rut.rutina_actividades?.length || 0 }} actividades
          </span>
          <div class="d-flex gap-3">
            <i class="bi bi-eye text-dark fs-5" @click="abrirDetalle(rut)"></i>
            <i
              class="bi bi-pencil-square text-verde fs-5"
              @click="abrirModalEditar(rut)"
            ></i>
            <i
              class="bi bi-trash3-fill text-danger fs-5"
              @click="confirmarEliminar(rut)"
            ></i>
          </div>
        </div>
      </div>

      <!-- Paginación móvil -->
      <div class="paginacion-mobile">
        <div class="pag-mobile-top">
          <small class="pag-info"
            >{{ rangoInicio }}–{{ rangoFin }} de {{ rutinasOrdenadas.length }}</small
          >
          <div class="por-pagina-wrap">
            <label class="por-pagina-label">Filas:</label>
            <select
              class="por-pagina-select"
              :value="paginacionStore.porPagina"
              @change="cambiarPorPagina(Number($event.target.value))"
            >
              <option v-for="n in paginacionStore.opcionesPorPagina" :key="n" :value="n">
                {{ n }}
              </option>
            </select>
          </div>
        </div>
        <div class="pag-mobile-nav">
          <button
            class="btn-pag-mobile"
            :disabled="paginaActual === 1"
            @click="paginaActual--"
          >
            <i class="bi bi-chevron-left"></i> Anterior
          </button>
          <small class="text-verde fw-bold"
            >{{ paginaActual }} / {{ totalPaginas }}</small
          >
          <button
            class="btn-pag-mobile"
            :disabled="paginaActual === totalPaginas"
            @click="paginaActual++"
          >
            Siguiente <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ══════════════════════ MODAL CREAR / EDITAR ══════════════════════ -->
    <div class="modal fade" id="modalRutina" tabindex="-1" ref="modalElement">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content divisan-modal border-0">
          <!-- Header -->
          <div class="modal-header border-0 pb-0">
            <h5 class="fw-bold text-cafe">
              {{ store.modoEdicion ? "Editar rutina" : "Nueva rutina" }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <!-- Pestañas -->
          <div class="modal-body pt-2">
            <ul class="nav nav-tabs divisan-tabs mb-3">
              <li class="nav-item">
                <button
                  :class="['nav-link', { active: tabActivo === 1 }]"
                  @click="tabActivo = 1"
                >
                  <i class="bi bi-clipboard-data me-1"></i>Datos generales
                </button>
              </li>
              <li class="nav-item">
                <button
                  :class="['nav-link', { active: tabActivo === 2 }]"
                  @click="tabActivo = 2"
                >
                  <i class="bi bi-list-check me-1"></i>Actividades
                  <span v-if="store.totalActividades" class="tab-badge ms-1">
                    {{ store.totalActividades }}
                  </span>
                </button>
              </li>
              <li class="nav-item">
                <button
                  :class="['nav-link', { active: tabActivo === 3 }]"
                  @click="tabActivo = 3"
                >
                  <i class="bi bi-box2 me-1"></i>Refacciones
                  <span v-if="store.totalRefacciones" class="tab-badge ms-1">
                    {{ store.totalRefacciones }}
                  </span>
                </button>
              </li>
            </ul>

            <!-- ── TAB 1: Datos generales ── -->
            <div v-show="tabActivo === 1">
              <div class="row g-3">
                <div class="col-12">
                  <label class="form-label label-divisan"
                    >Nombre de la rutina <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="store.borrador.nombre"
                    type="text"
                    class="form-control divisan-input-modal"
                    placeholder="Ej. Revisión sistema electromecánico"
                  />
                </div>

                <!-- Área de trabajo -->
                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan"
                    >Área de trabajo <span class="text-danger">*</span></label
                  >
                  <select
                    :value="store.borrador.area"
                    class="form-select divisan-input-modal"
                    @change="
                      store.borrador.area = $event.target.value
                        ? parseInt($event.target.value)
                        : null
                    "
                  >
                    <option :value="null">Selecciona un área</option>
                    <option v-for="area in areas" :key="area.id" :value="area.id">
                      {{ area.nombre }}
                    </option>
                  </select>
                </div>

                <!-- Periodicidad -->
                <div class="col-12 col-md-6" v-click-outside="cerrarModalPeriodicidad">
                  <label class="form-label label-divisan"
                    >Periodicidad <span class="text-danger">*</span></label
                  >
                  <div class="custom-select-wrapper">
                    <div
                      class="form-control divisan-input-modal custom-select-input modal-display"
                      @click="abiertoModalPeriodicidad = !abiertoModalPeriodicidad"
                    >
                      <span v-if="store.borrador.periodicidad" class="text-cafe">
                        {{
                          opcionesPeriodicidad.find(
                            (o) => o.value === store.borrador.periodicidad
                          )?.label || store.borrador.periodicidad
                        }}
                      </span>
                      <span v-else class="text-muted">Selecciona periodicidad</span>
                    </div>
                    <i
                      class="bi custom-select-arrow"
                      :class="
                        abiertoModalPeriodicidad ? 'bi-chevron-up' : 'bi-chevron-down'
                      "
                      @mousedown.prevent="
                        abiertoModalPeriodicidad = !abiertoModalPeriodicidad
                      "
                      style="pointer-events: auto; cursor: pointer"
                    ></i>
                    <div v-if="abiertoModalPeriodicidad" class="custom-dropdown">
                      <div
                        v-for="op in opcionesPeriodicidad"
                        :key="op.value"
                        class="custom-dropdown-item"
                        :class="{ selected: store.borrador.periodicidad === op.value }"
                        @mousedown.prevent="
                          store.borrador.periodicidad = op.value;
                          abiertoModalPeriodicidad = false;
                        "
                      >
                        {{ op.label }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan"
                    >Duración estimada (horas)</label
                  >
                  <input
                    v-model.number="store.borrador.duracion_estimada_horas"
                    type="number"
                    step="0.5"
                    min="0"
                    class="form-control divisan-input-modal"
                    placeholder="Ej. 2.5"
                  />
                </div>

                <div class="col-12">
                  <label class="form-label label-divisan"
                    >Descripción
                    <span class="text-cafe opacity-50 small">(opcional)</span></label
                  >
                  <textarea
                    v-model="store.borrador.descripcion"
                    class="form-control divisan-input-modal"
                    rows="3"
                    placeholder="Describe el alcance o propósito de esta rutina..."
                  ></textarea>
                </div>
              </div>
            </div>

            <!-- ── TAB 2: Actividades ── -->
            <div v-show="tabActivo === 2">
              <div class="agregar-row mb-3">
                <div
                  class="custom-select-wrapper flex-grow-1"
                  v-click-outside="cerrarDropActividad"
                >
                  <div
                    class="form-control divisan-input-modal custom-select-input modal-display"
                    @click="abiertoDropActividad = !abiertoDropActividad"
                  >
                    <span v-if="actividadSeleccionada" class="text-cafe">{{
                      actividadSeleccionada.nombre
                    }}</span>
                    <span v-else class="text-muted">Selecciona actividad...</span>
                  </div>
                  <i
                    class="bi custom-select-arrow"
                    :class="abiertoDropActividad ? 'bi-chevron-up' : 'bi-chevron-down'"
                    @mousedown.prevent="abiertoDropActividad = !abiertoDropActividad"
                    style="pointer-events: auto; cursor: pointer"
                  ></i>
                  <div v-if="abiertoDropActividad" class="custom-dropdown">
                    <div
                      v-for="act in catActividades"
                      :key="act.id"
                      class="custom-dropdown-item"
                      :class="{ selected: actividadSeleccionada?.id === act.id }"
                      @mousedown.prevent="
                        actividadSeleccionada = act;
                        abiertoDropActividad = false;
                      "
                    >
                      {{ act.nombre }}
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-agregar"
                  @click="agregarActividad"
                  :disabled="!actividadSeleccionada"
                >
                  <i class="bi bi-plus-lg me-1"></i>Agregar
                </button>
              </div>

              <div v-if="store.actividadesOrdenadas.length === 0" class="empty-state">
                <i class="bi bi-list-check opacity-25"></i>
                <p class="mt-2 text-cafe opacity-50">
                  Aún no hay actividades en esta rutina
                </p>
              </div>

              <div v-else class="actividades-lista">
                <div
                  v-for="act in store.actividadesOrdenadas"
                  :key="act._tempId"
                  class="actividad-row"
                >
                  <span class="orden-badge">{{ act.orden }}</span>
                  <span class="actividad-nombre flex-grow-1">{{
                    act.actividad_nombre
                  }}</span>
                  <button
                    type="button"
                    class="btn-quitar"
                    @click="store.quitarActividad(act._tempId)"
                    title="Quitar actividad"
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- ── TAB 3: Refacciones ── -->
            <div v-show="tabActivo === 3">
              <div class="agregar-row mb-3">
                <div
                  class="custom-select-wrapper flex-grow-1"
                  v-click-outside="cerrarDropRefaccion"
                >
                  <div
                    class="form-control divisan-input-modal custom-select-input modal-display"
                    @click="abiertoDropRefaccion = !abiertoDropRefaccion"
                  >
                    <span v-if="refaccionSeleccionada" class="text-cafe">
                      {{ refaccionSeleccionada.nombre_refaccion }}
                      <span
                        v-if="refaccionSeleccionada.en_almacen"
                        class="text-verde ms-1"
                        >✓</span
                      >
                    </span>
                    <span v-else class="text-muted"
                      >Selecciona una refacción del catálogo...</span
                    >
                  </div>
                  <i
                    class="bi custom-select-arrow"
                    :class="abiertoDropRefaccion ? 'bi-chevron-up' : 'bi-chevron-down'"
                    @mousedown.prevent="abiertoDropRefaccion = !abiertoDropRefaccion"
                    style="pointer-events: auto; cursor: pointer"
                  ></i>
                  <div v-if="abiertoDropRefaccion" class="custom-dropdown">
                    <div
                      v-for="ref in catRefacciones"
                      :key="ref.id"
                      class="custom-dropdown-item"
                      :class="{ selected: refaccionSeleccionada?.id === ref.id }"
                      @mousedown.prevent="
                        refaccionSeleccionada = ref;
                        abiertoDropRefaccion = false;
                      "
                    >
                      {{ ref.nombre_refaccion }}
                      <span v-if="ref.en_almacen" class="text-verde ms-1 small">✓</span>
                    </div>
                  </div>
                </div>
                <input
                  v-model.number="cantidadRefaccion"
                  type="number"
                  min="1"
                  class="form-control divisan-input-modal input-cantidad"
                  placeholder="Cant."
                />
                <button
                  type="button"
                  class="btn btn-agregar"
                  @click="agregarRefaccion"
                  :disabled="!refaccionSeleccionada || !cantidadRefaccion"
                >
                  <i class="bi bi-plus-lg me-1"></i>Agregar
                </button>
              </div>

              <div v-if="store.borradorRefacciones.length === 0" class="empty-state">
                <i class="bi bi-box2 opacity-25"></i>
                <p class="mt-2 text-cafe opacity-50">
                  No se requieren refacciones para esta rutina
                </p>
              </div>

              <div v-else class="actividades-lista">
                <div
                  v-for="ref in store.borradorRefacciones"
                  :key="ref._tempId"
                  class="actividad-row"
                >
                  <span class="actividad-nombre flex-grow-1">{{
                    ref.refaccion_nombre
                  }}</span>
                  <span class="cantidad-badge">× {{ ref.cantidad }}</span>
                  <button
                    type="button"
                    class="btn-quitar"
                    @click="store.quitarRefaccion(ref._tempId)"
                    title="Quitar refacción"
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer border-0 pt-0">
            <div class="w-100 d-flex justify-content-between align-items-center">
              <small class="text-cafe opacity-60">
                <i class="bi bi-layers me-1"></i>
                {{ store.totalActividades }} actividad(es) ·
                {{ store.totalRefacciones }} refacción(es)
              </small>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  class="btn btn-nuevo py-2 px-4"
                  @click="guardarRutina"
                  :disabled="store.guardando || store.actividadesOrdenadas.length === 0"
                  :title="
                    store.actividadesOrdenadas.length === 0
                      ? 'Agrega al menos una actividad'
                      : ''
                  "
                >
                  <span
                    v-if="store.guardando"
                    class="spinner-border spinner-border-sm me-2"
                  ></span>
                  {{ store.modoEdicion ? "Actualizar" : "Guardar" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════
         MODAL ÁREAS DE TRABAJO
    ══════════════════════════════════════════════════════ -->
    <div
      class="modal fade"
      id="modalAreas"
      tabindex="-1"
      ref="modalAreasElement"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content divisan-modal border-0">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title fw-bold text-cafe">
              <i class="bi bi-diagram-3-fill me-2"></i>Áreas de trabajo
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body pt-2">
            <!-- Formulario inline agregar / editar área -->
            <div class="cat-form-wrapper mb-4">
              <div class="row g-2 align-items-end">
                <div class="col-12 col-md-4">
                  <label class="form-label label-divisan mb-1"
                    >Nombre <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="areaForm.nombre"
                    type="text"
                    class="form-control divisan-input-modal"
                    placeholder="Ej. Inyección, Taller, Almacén..."
                    maxlength="100"
                  />
                </div>
                <div class="col-12 col-md-5">
                  <label class="form-label label-divisan mb-1"
                    >Descripción <span class="text-muted-divisan">(opcional)</span></label
                  >
                  <input
                    v-model="areaForm.descripcion"
                    type="text"
                    class="form-control divisan-input-modal"
                    placeholder="Descripción breve..."
                    maxlength="200"
                  />
                </div>
                <div class="col-12 col-md-3 d-flex gap-2">
                  <button
                    class="btn btn-nuevo flex-grow-1"
                    :disabled="!areaForm.nombre.trim() || areaGuardando"
                    @click="guardarArea"
                  >
                    <span
                      v-if="areaGuardando"
                      class="spinner-border spinner-border-sm me-1"
                    ></span>
                    {{ areaEditando ? "Actualizar" : "Agregar" }}
                  </button>
                  <button
                    v-if="areaEditando"
                    class="btn btn-cancelar px-3"
                    @click="cancelarEdicionArea"
                    title="Cancelar edición"
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Lista de áreas -->
            <div v-if="areaLoading" class="text-center py-4">
              <div class="spinner-border text-verde"></div>
            </div>

            <div
              v-else-if="areas.length === 0"
              class="text-center py-4 text-cafe opacity-50 fw-bold"
            >
              No hay áreas registradas
            </div>

            <div v-else class="cat-lista">
              <div
                v-for="area in areas"
                :key="area.id"
                class="cat-item d-flex justify-content-between align-items-center px-3 py-2"
                :class="{ 'cat-editando': areaForm.id === area.id }"
              >
                <div class="d-flex flex-column">
                  <span class="fw-bold text-cafe">{{ area.nombre }}</span>
                  <small v-if="area.descripcion" class="text-muted-divisan">{{
                    area.descripcion
                  }}</small>
                </div>
                <div class="d-flex gap-2">
                  <button
                    class="btn-circular-sm"
                    @click="editarArea(area)"
                    title="Editar"
                  >
                    <i class="bi bi-pencil-square text-verde"></i>
                  </button>
                  <button
                    class="btn-circular-sm"
                    @click="confirmarDesactivarArea(area)"
                    title="Desactivar"
                  >
                    <i class="bi bi-trash3-fill text-danger"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-cancelar px-4" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════ MODAL DETALLE ══════════════════════ -->
    <div
      class="modal fade"
      id="modalDetalleRutina"
      tabindex="-1"
      ref="modalDetalleElement"
    >
      <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content divisan-modal border-0">
          <div class="modal-header border-0 pb-1">
            <div>
              <h5 class="fw-bold text-cafe mb-1">{{ detalleRutina?.nombre }}</h5>
              <div class="d-flex gap-2 flex-wrap">
                <span v-if="detalleRutina?.area_nombre" class="badge-area">
                  {{ detalleRutina.area_nombre }}
                </span>
              </div>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body pt-2">
            <div class="detalle-grid mb-3">
              <div>
                <span class="detalle-mini-label">Periodicidad</span>
                <div class="detalle-mini-valor">
                  {{ labelPeriodicidad(detalleRutina?.periodicidad) }}
                  <small v-if="detalleRutina?.frecuencia_dias" class="text-verde ms-1">
                    (c/{{ detalleRutina.frecuencia_dias }} días)
                  </small>
                </div>
              </div>
              <div>
                <span class="detalle-mini-label">Duración estimada</span>
                <div class="detalle-mini-valor">
                  {{
                    detalleRutina?.duracion_estimada_horas
                      ? detalleRutina.duracion_estimada_horas + " hrs"
                      : "—"
                  }}
                </div>
              </div>
            </div>

            <div v-if="detalleRutina?.descripcion" class="detalle-seccion mb-3">
              <span class="detalle-mini-label">Descripción</span>
              <div class="detalle-mini-valor">{{ detalleRutina.descripcion }}</div>
            </div>

            <div class="detalle-seccion mb-3">
              <span class="detalle-mini-label">
                Actividades ({{ detalleRutina?.rutina_actividades?.length || 0 }})
              </span>
              <div v-if="detalleRutina?.rutina_actividades?.length" class="mt-2">
                <div
                  v-for="act in detalleRutina.rutina_actividades"
                  :key="act.id"
                  class="detalle-actividad-row"
                >
                  <span class="orden-badge-sm">{{ act.orden }}</span>
                  <span class="detalle-mini-valor">{{ act.actividad_nombre }}</span>
                </div>
              </div>
              <div v-else class="detalle-mini-valor opacity-50 mt-1">
                Sin actividades registradas
              </div>
            </div>

            <div class="detalle-seccion">
              <span class="detalle-mini-label">
                Refacciones requeridas ({{
                  detalleRutina?.rutina_refacciones?.length || 0
                }})
              </span>
              <div v-if="detalleRutina?.rutina_refacciones?.length" class="mt-2">
                <div
                  v-for="ref in detalleRutina.rutina_refacciones"
                  :key="ref.id"
                  class="detalle-actividad-row"
                >
                  <span class="actividad-nombre flex-grow-1">{{
                    ref.refaccion_nombre
                  }}</span>
                  <span class="cantidad-badge">× {{ ref.cantidad }}</span>
                </div>
              </div>
              <div v-else class="detalle-mini-valor opacity-50 mt-1">
                No requiere refacciones
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import {
  getActividades,
  getRefacciones,
  getAreasTrabajo,
  crearAreaTrabajo,
  actualizarAreaTrabajo,
  eliminarAreaTrabajo,
} from "@/utils/api_backend";
import { useRutinaStore } from "../../store/useRutinaStore";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import CrudToolbar from "@/components/Shared/CrudToolbar.vue";
import ColumnFilterMenu from "@/components/Shared/ColumnFilterMenu.vue";

const store = useRutinaStore();

// ── Catálogos ───────────────────────────────────────────────
const catActividades = ref([]);
const catRefacciones = ref([]);
const areas = ref([]);

// ── UI del modal ────────────────────────────────────────────
const tabActivo = ref(1);
const actividadSeleccionada = ref("");
const refaccionSeleccionada = ref("");
const cantidadRefaccion = ref(1);
const detalleRutina = ref(null);

// ── Filtros tabla ───────────────────────────────────────────
const filtroTexto = ref("");
const filtroAreaSet = ref(new Set());
const paginaActual = ref(1);

// ── Store paginación ─────────────────────────────────────────
import { usePaginacionRutinasStore } from "@/store/paginacionStore";
const paginacionStore = usePaginacionRutinasStore();

// ── Ordenamiento ─────────────────────────────────────────────
const sortKey = ref("nombre");
const sortDir = ref("asc");

function onSort({ field, asc }) {
  sortKey.value = field;
  sortDir.value = asc ? "asc" : "desc";
  paginaActual.value = 1;
}

// ── Modal Áreas ──────────────────────────────────────────────
const modalAreasElement = ref(null);
let modalAreasInstance = null;
const areaLoading = ref(false);
const areaGuardando = ref(false);
const areaEditando = ref(false);

const areaFormVacio = () => ({ id: null, nombre: "", descripcion: "" });
const areaForm = ref(areaFormVacio());

function abrirModalAreas() {
  cancelarEdicionArea();
  modalAreasInstance.show();
}

function editarArea(area) {
  areaEditando.value = true;
  areaForm.value = {
    id: area.id,
    nombre: area.nombre,
    descripcion: area.descripcion || "",
  };
}

function cancelarEdicionArea() {
  areaEditando.value = false;
  areaForm.value = areaFormVacio();
}

async function guardarArea() {
  if (!areaForm.value.nombre.trim()) return;
  areaGuardando.value = true;
  try {
    const payload = {
      nombre: areaForm.value.nombre.trim(),
      descripcion: areaForm.value.descripcion.trim() || null,
    };
    if (areaEditando.value) {
      await actualizarAreaTrabajo(areaForm.value.id, payload);
    } else {
      await crearAreaTrabajo(payload);
    }
    cancelarEdicionArea();
    await cargarAreas();
    Swal.fire({
      icon: "success",
      title: areaEditando.value ? "Área actualizada" : "Área creada",
      timer: 1800,
      showConfirmButton: false,
    });
  } catch (err) {
    const msg =
      err?.response?.data?.nombre?.[0] ||
      err?.response?.data?.non_field_errors?.[0] ||
      "No se pudo guardar el área";
    Swal.fire("Error", msg, "error");
  } finally {
    areaGuardando.value = false;
  }
}

async function confirmarDesactivarArea(area) {
  const res = await Swal.fire({
    title: `¿Desactivar "${area.nombre}"?`,
    text: "Las rutinas que usan esta área la conservarán en su historial.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "var(--d-brown)",
    cancelButtonColor: "var(--d-green)",
    confirmButtonText: "Sí, desactivar",
    cancelButtonText: "Cancelar",
  });
  if (!res.isConfirmed) return;
  try {
    await eliminarAreaTrabajo(area.id);
    await cargarAreas();
    Swal.fire({
      icon: "success",
      title: "Desactivada",
      timer: 1800,
      showConfirmButton: false,
    });
  } catch {
    Swal.fire("Error", "No se pudo desactivar el área", "error");
  }
}

// ── Dropdowns modal Tab 1 ─────────────────────────────────────
const abiertoModalPeriodicidad = ref(false);
const opcionesPeriodicidad = [
  { value: "SEMANAL", label: "Semanal (c/7 días)" },
  { value: "MENSUAL", label: "Mensual (c/30 días)" },
  { value: "TRIMESTRAL", label: "Trimestral (c/90 días)" },
  { value: "SEMESTRAL", label: "Semestral (c/180 días)" },
  { value: "ANUAL", label: "Anual (c/365 días)" },
];
function cerrarModalPeriodicidad() {
  abiertoModalPeriodicidad.value = false;
}

// ── Dropdowns Tab 2 y Tab 3 ───────────────────────────────────
const abiertoDropActividad = ref(false);
function cerrarDropActividad() {
  abiertoDropActividad.value = false;
}

const abiertoDropRefaccion = ref(false);
function cerrarDropRefaccion() {
  abiertoDropRefaccion.value = false;
}

// ── Directiva click-outside ───────────────────────────────────
const vClickOutside = {
  mounted(el, b) {
    el._co = (e) => {
      if (!el.contains(e.target)) b.value(e);
    };
    document.addEventListener("click", el._co);
  },
  unmounted(el) {
    document.removeEventListener("click", el._co);
  },
};

// ── Refs de modales Bootstrap ───────────────────────────────
const modalElement = ref(null);
const modalDetalleElement = ref(null);
let modalInstance = null;
let modalDetalleInstance = null;

// ── Watchers ────────────────────────────────────────────────
watch([filtroTexto, filtroAreaSet], () => {
  paginaActual.value = 1;
});

// ── Computed ────────────────────────────────────────────────
const rutinasBuscadas = computed(() => {
  const q = filtroTexto.value.toLowerCase();
  return store.rutinas.filter((r) => !q || r.nombre.toLowerCase().includes(q));
});

const rutinasFiltradas = computed(() =>
  rutinasBuscadas.value.filter(
    (r) => !filtroAreaSet.value.size || filtroAreaSet.value.has(r.area_nombre)
  )
);

const rutinasOrdenadas = computed(() =>
  [...rutinasFiltradas.value].sort((a, b) => {
    const va = (a[sortKey.value] || "").toString().toLowerCase();
    const vb = (b[sortKey.value] || "").toString().toLowerCase();
    if (va < vb) return sortDir.value === "asc" ? -1 : 1;
    if (va > vb) return sortDir.value === "asc" ? 1 : -1;
    return 0;
  })
);

const totalPaginas = computed(() =>
  Math.max(1, Math.ceil(rutinasOrdenadas.value.length / paginacionStore.porPagina))
);

const rutinasPaginadas = computed(() => {
  const ini = (paginaActual.value - 1) * paginacionStore.porPagina;
  return rutinasOrdenadas.value.slice(ini, ini + paginacionStore.porPagina);
});

const rangoInicio = computed(() =>
  rutinasOrdenadas.value.length === 0
    ? 0
    : (paginaActual.value - 1) * paginacionStore.porPagina + 1
);
const rangoFin = computed(() =>
  Math.min(paginaActual.value * paginacionStore.porPagina, rutinasOrdenadas.value.length)
);
const paginasVisibles = computed(() => {
  const total = totalPaginas.value;
  const actual = paginaActual.value;
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const set = new Set([1, total, actual]);
  if (actual > 1) set.add(actual - 1);
  if (actual < total) set.add(actual + 1);
  const ordenadas = [...set].sort((a, b) => a - b);
  const resultado = [];
  for (let i = 0; i < ordenadas.length; i++) {
    if (i > 0 && ordenadas[i] - ordenadas[i - 1] > 1) resultado.push("...");
    resultado.push(ordenadas[i]);
  }
  return resultado;
});

function cambiarPorPagina(n) {
  paginacionStore.setPorPagina(n);
  paginaActual.value = 1;
}

// ── Labels ──────────────────────────────────────────────────
const LABELS_PERIODICIDAD = {
  SEMANAL: "Semanal",
  MENSUAL: "Mensual",
  TRIMESTRAL: "Trimestral",
  SEMESTRAL: "Semestral",
  ANUAL: "Anual",
};
const labelPeriodicidad = (v) => LABELS_PERIODICIDAD[v] || v || "—";

// ── Carga de catálogos ───────────────────────────────────────
async function cargarAreas() {
  areaLoading.value = true;
  try {
    const data = await getAreasTrabajo();
    areas.value = Array.isArray(data) ? data : data.results ?? [];
  } catch {
    Swal.fire("Error", "No se pudieron cargar las áreas", "error");
  } finally {
    areaLoading.value = false;
  }
}

// ── Abrir modales ───────────────────────────────────────────
function abrirModalCrear() {
  store.iniciarCreacion();
  tabActivo.value = 1;
  actividadSeleccionada.value = "";
  refaccionSeleccionada.value = "";
  cantidadRefaccion.value = 1;
  modalInstance?.show();
}

function abrirModalEditar(rutina) {
  store.iniciarEdicion(rutina);
  tabActivo.value = 1;
  actividadSeleccionada.value = "";
  refaccionSeleccionada.value = "";
  cantidadRefaccion.value = 1;
  modalInstance?.show();
}

function abrirDetalle(rutina) {
  detalleRutina.value = rutina;
  modalDetalleInstance?.show();
}

// ── Agregar actividad / refacción ───────────────────────────
function agregarActividad() {
  if (!actividadSeleccionada.value) return;
  const resultado = store.agregarActividad(
    actividadSeleccionada.value.id,
    actividadSeleccionada.value.nombre
  );
  if (resultado?.error) {
    Swal.fire({
      icon: "warning",
      title: "Atención",
      text: resultado.error,
      confirmButtonColor: "var(--d-brown)",
    });
  } else {
    actividadSeleccionada.value = "";
  }
}

function agregarRefaccion() {
  if (!refaccionSeleccionada.value || !cantidadRefaccion.value) return;
  const resultado = store.agregarRefaccion(
    refaccionSeleccionada.value.id,
    refaccionSeleccionada.value.nombre_refaccion,
    cantidadRefaccion.value
  );
  if (resultado?.error) {
    Swal.fire({
      icon: "warning",
      title: "Atención",
      text: resultado.error,
      confirmButtonColor: "var(--d-brown)",
    });
  } else {
    refaccionSeleccionada.value = "";
    cantidadRefaccion.value = 1;
  }
}

// ── Guardar ─────────────────────────────────────────────────
async function guardarRutina() {
  const b = store.borrador;
  if (!b.nombre || !b.area || !b.periodicidad) {
    Swal.fire({
      icon: "warning",
      title: "Datos incompletos",
      text: "Completa al menos: nombre, área de trabajo y periodicidad.",
      confirmButtonColor: "var(--d-brown)",
    });
    tabActivo.value = 1;
    return;
  }

  if (store.actividadesOrdenadas.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "Sin actividades",
      text: "Debes agregar al menos una actividad antes de guardar la rutina.",
      confirmButtonColor: "var(--d-brown)",
    });
    tabActivo.value = 2;
    return;
  }

  const resultado = await store.guardarTodo();

  if (!resultado.ok) {
    Swal.fire({
      icon: "error",
      title: "Error al guardar",
      text: resultado.error,
      confirmButtonColor: "var(--d-brown)",
    });
    return;
  }

  modalInstance.hide();

  if (resultado.erroresParciales?.length) {
    Swal.fire({
      icon: "warning",
      title: "Rutina guardada con advertencias",
      html: `<p>La rutina se guardó correctamente, pero ocurrieron algunos problemas:</p>
             <ul class="text-start mt-2">
               ${resultado.erroresParciales.map((e) => `<li>${e}</li>`).join("")}
             </ul>
             <p class="mt-2">Puedes editarla para corregirlos.</p>`,
      confirmButtonColor: "var(--d-brown)",
    });
  } else {
    Swal.fire({
      icon: "success",
      title: "Operación exitosa",
      text: `Rutina ${store.modoEdicion ? "actualizada" : "creada"} correctamente`,
      timer: 2000,
      showConfirmButton: false,
    });
  }
}

// ── Eliminar ─────────────────────────────────────────────────
async function confirmarEliminar(rutina) {
  const result = await Swal.fire({
    title: `¿Desactivar "${rutina.nombre}"?`,
    text: "La rutina y su historial se conservan, pero no podrá programarse.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "var(--d-brown)",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Sí, desactivar",
    cancelButtonText: "Cancelar",
  });
  if (result.isConfirmed) {
    try {
      await store.eliminarRutina(rutina.id);
      Swal.fire({
        icon: "success",
        title: "Desactivada",
        text: "La rutina ha sido deshabilitada.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch {
      Swal.fire("Error", "No se pudo desactivar la rutina.", "error");
    }
  }
}

// ── Init ─────────────────────────────────────────────────────
onMounted(async () => {
  modalInstance = new Modal(modalElement.value);
  modalDetalleInstance = new Modal(modalDetalleElement.value);
  modalAreasInstance = new Modal(modalAreasElement.value);

  await store.cargarRutinas();
  const [act, ref] = await Promise.all([getActividades(), getRefacciones()]);
  catActividades.value = act;
  catRefacciones.value = ref;
  await cargarAreas();
});
</script>

<style scoped>
.text-cafe {
  color: var(--d-brown);
}
.text-verde {
  color: var(--d-green);
}
.text-muted-divisan {
  color: rgba(64, 34, 8, 0.6);
  font-weight: 500;
  font-size: 0.85rem;
}

.btn-header {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.btn-areas {
  background-color: var(--d-green);
  color: var(--d-cream);
}
.btn-areas:hover {
  background-color: var(--d-green-dark);
  color: var(--d-cream);
}

.divisan-table-container {
  background-color: var(--d-cream);
  border-radius: 15px;
  overflow: hidden;
}
.table-divisan thead th {
  background: var(--d-cream);
  color: var(--d-brown);
  border-bottom: 3px solid var(--d-brown);
  padding: 15px;
  font-weight: 800;
  text-transform: capitalize;
  border-top: none;
}
.table-divisan td {
  border-bottom: 1px solid rgba(96, 108, 56, 0.1);
  padding: 12px;
}

/* ── Badge de área ── */
.badge-area {
  background: rgba(96, 108, 56, 0.12);
  color: var(--d-green-dark);
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  border: 1px solid rgba(96, 108, 56, 0.2);
}

.periodicidad-cell {
  line-height: 1.3;
}
.conteo-badge {
  background-color: rgba(96, 108, 56, 0.12);
  color: var(--d-green-dark);
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 700;
}
.descripcion-corta {
  font-size: 0.75rem;
  color: var(--d-green);
  opacity: 0.8;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

/* ── Acciones ── */
.btn-circular {
  background: white;
  border: 1px solid var(--d-green);
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}
.btn-circular:hover {
  background-color: rgba(96, 108, 56, 0.1);
}
.btn-circular-sm {
  background: white;
  border: 1px solid var(--d-green);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  font-size: 0.8rem;
}
.btn-circular-sm:hover {
  background: rgba(96, 108, 56, 0.1);
}

/* ── Paginación ── */
.paginacion-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  flex-wrap: wrap;
  gap: 8px;
  border-top: 1px solid rgba(64, 34, 8, 0.1);
  background: rgba(96, 108, 56, 0.05);
}
.pag-izq {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.pag-der {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pag-info {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.por-pagina-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-select {
  appearance: none;
  -webkit-appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23606c38' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E")
    no-repeat right 8px center;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  padding: 3px 26px 3px 10px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--d-brown);
  cursor: pointer;
  outline: none;
  min-width: 58px;
}
.btn-pag {
  background: white;
  border: 1px solid var(--d-green);
  color: var(--d-brown);
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-pag:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}
.btn-pag:disabled {
  opacity: 0.35;
  cursor: default;
}
.btn-pag-num {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.25);
  color: var(--d-brown);
  border-radius: 8px;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.82rem;
  font-weight: 700;
}
.btn-pag-num:hover {
  background: rgba(96, 108, 56, 0.1);
  border-color: var(--d-green);
}
.btn-pag-num.activo {
  background: var(--d-brown);
  color: var(--d-cream);
  border-color: var(--d-brown);
  pointer-events: none;
}
.pag-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 32px;
  font-size: 0.85rem;
  color: var(--d-brown);
  opacity: 0.4;
  font-weight: 700;
}

/* ── Mobile ── */
.divisan-mobile-card {
  background-color: var(--d-cream);
  border-radius: 15px;
  border-left: 6px solid var(--d-green);
}
.paginacion-mobile {
  border-top: 1px solid rgba(64, 34, 8, 0.15);
  padding: 10px 4px;
  margin-top: 4px;
}
.pag-mobile-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}
.pag-mobile-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-pag-mobile {
  background: var(--d-cream);
  border: 1px solid var(--d-green);
  color: var(--d-brown);
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 110px;
  justify-content: center;
}
.btn-pag-mobile:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}
.btn-pag-mobile:disabled {
  opacity: 0.35;
  cursor: default;
}

/* ── Modal ── */
.divisan-modal {
  background-color: var(--d-cream);
  border: 2px solid var(--d-brown);
  border-radius: 20px;
}
.label-divisan {
  color: var(--d-brown);
  font-weight: 700;
}
.divisan-input-modal {
  border: 1px solid var(--d-green);
  border-radius: 8px;
  color: var(--d-brown);
}
.divisan-input-modal:focus {
  border-color: var(--d-green-dark);
  box-shadow: 0 0 0 0.2rem rgba(96, 108, 56, 0.2);
}
.btn-nuevo {
  background-color: var(--d-brown);
  color: var(--d-cream);
  border: none;
  font-weight: 600;
  padding: 0.6rem 1.5rem;
  border-radius: 8px;
}
.btn-nuevo:hover:not(:disabled) {
  background-color: var(--d-green-dark);
  color: var(--d-cream);
}
.btn-cancelar {
  background: white;
  border: 1px solid var(--d-green);
  color: var(--d-brown);
  font-weight: 600;
  border-radius: 8px;
  padding: 0.5rem 1rem;
}
.btn-cancelar:hover {
  background: rgba(96, 108, 56, 0.08);
}

/* ── Pestañas ── */
.divisan-tabs {
  border-bottom: 2px solid rgba(96, 108, 56, 0.2);
}
.divisan-tabs .nav-link {
  color: var(--d-brown);
  font-weight: 600;
  font-size: 0.88rem;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 0.5rem 1rem;
  background: none;
  transition: all 0.2s;
  border-radius: 0;
}
.divisan-tabs .nav-link:hover {
  color: var(--d-green);
  background-color: rgba(96, 108, 56, 0.06);
}
.divisan-tabs .nav-link.active {
  color: var(--d-brown);
  border-bottom: 3px solid var(--d-brown);
  background-color: transparent;
}
.tab-badge {
  background-color: var(--d-green);
  color: var(--d-cream);
  font-size: 0.65rem;
  font-weight: 800;
  padding: 1px 6px;
  border-radius: 10px;
  vertical-align: middle;
}

/* ── Fila agregar ── */
.agregar-row {
  display: flex;
  gap: 8px;
  align-items: center;
}
.btn-agregar {
  background-color: var(--d-green);
  color: var(--d-cream);
  border: none;
  font-weight: 600;
  font-size: 0.85rem;
  white-space: nowrap;
  border-radius: 8px;
  padding: 0.45rem 0.9rem;
}
.btn-agregar:hover:not(:disabled) {
  background-color: var(--d-green-dark);
  color: var(--d-cream);
}
.btn-agregar:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.input-cantidad {
  max-width: 80px;
  text-align: center;
}

/* ── Lista de actividades/refacciones ── */
.actividades-lista {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.actividad-row {
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  border: 1px solid rgba(96, 108, 56, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  transition: background 0.15s;
}
.actividad-row:hover {
  background-color: rgba(96, 108, 56, 0.04);
}
.orden-badge {
  background-color: var(--d-brown);
  color: var(--d-cream);
  font-size: 0.72rem;
  font-weight: 800;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.actividad-nombre {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--d-brown);
}
.cantidad-badge {
  font-size: 0.8rem;
  font-weight: 800;
  color: var(--d-green);
  white-space: nowrap;
}
.btn-quitar {
  background: none;
  border: none;
  color: #a32d2d;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 2px 4px;
  border-radius: 4px;
  transition: background 0.15s;
}
.btn-quitar:hover {
  background-color: rgba(163, 45, 45, 0.1);
}

/* ── Empty states ── */
.empty-state {
  text-align: center;
  padding: 2rem 1rem;
  font-size: 2.5rem;
  color: var(--d-green);
}

/* ── Custom select ── */
.custom-select-wrapper {
  position: relative;
}
.custom-select-input {
  padding-right: 2.2rem !important;
}
.modal-display {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  min-height: 38px;
  background-color: white;
}
.custom-select-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--d-green);
  font-size: 0.8rem;
  cursor: pointer;
}
.custom-dropdown {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  z-index: 1080;
  background: white;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(40, 54, 24, 0.15);
  max-height: 200px;
  overflow-y: auto;
}
.custom-dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 0.88rem;
  color: var(--d-brown);
  border-bottom: 1px solid rgba(96, 108, 56, 0.08);
  transition: background 0.12s;
}
.custom-dropdown-item:last-child {
  border-bottom: none;
}
.custom-dropdown-item:hover,
.custom-dropdown-item.selected {
  background: rgba(96, 108, 56, 0.12);
}

/* ── Modal Áreas (estructura idéntica al modal de categorías) ── */
.cat-form-wrapper {
  background: rgba(96, 108, 56, 0.05);
  border: 1px solid rgba(96, 108, 56, 0.2);
  border-radius: 12px;
  padding: 1rem;
}
.cat-lista {
  border: 1px solid rgba(96, 108, 56, 0.15);
  border-radius: 12px;
  overflow: hidden;
}
.cat-item {
  border-bottom: 1px solid rgba(96, 108, 56, 0.1);
  background: var(--d-cream);
  transition: background 0.15s;
}
.cat-item:last-child {
  border-bottom: none;
}
.cat-item:hover {
  background: rgba(96, 108, 56, 0.05);
}
.cat-item.cat-editando {
  background: rgba(64, 34, 8, 0.05);
  border-left: 4px solid var(--d-brown);
}

/* ── Detalle ── */
.detalle-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.detalle-mini-label {
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--d-green);
  display: block;
  margin-bottom: 2px;
}
.detalle-mini-valor {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--d-brown);
}
.detalle-seccion {
  border-top: 1px solid rgba(96, 108, 56, 0.2);
  padding-top: 10px;
}
.detalle-actividad-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid rgba(96, 108, 56, 0.08);
}
.orden-badge-sm {
  background-color: var(--d-green);
  color: var(--d-cream);
  font-size: 0.68rem;
  font-weight: 800;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .modal-dialog {
    margin-top: 80px;
    margin-bottom: 40px;
  }
  .agregar-row {
    flex-wrap: wrap;
  }
  .input-cantidad {
    max-width: 100%;
  }
}

@media (max-width: 991.98px) {
  .btn-header-texto {
    display: none;
  }
  .btn-header {
    width: 36px;
    height: 36px;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
}
</style>
